import axios from "../httpHandler";

export const getCorporations = async () => {
    try {
        const result = await axios.get(`corporation`);
        return result?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const createCoroporation = async (data) => {
    return axios.post(`corporation`, data);
};

export const deleteCoroporation = async ({ id }) => {
    return axios.delete(`corporation/${id}`);
};

export const updateCoroporation = (data) => {
    return axios.put(`corporation/${data?.id}`, data);
};